/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'accountStore')
@observer
export default class AddNewSiteSuccess extends React.Component<*> {
  componentDidMount() {
    const { actionDrawerStore, accountStore, config }: TypeProps = this.props;
    const LOCATION_COLUMN_BUILDING = 2;

    if (typeof accountStore.locationLists[3] === 'string') {
      accountStore.locationLists[3] = [{ active: [] }];
    }

    accountStore.locationLists[3][0].active.push(actionDrawerStore.response);

    actionDrawerStore.locationColumn = LOCATION_COLUMN_BUILDING;
    actionDrawerStore.closeActionDrawer();
  }

  render(): React.Element<*> {
    return 'success';
  }
}
